import { render, staticRenderFns } from "./ComponentSelector.vue?vue&type=template&id=512c024e&scoped=true&"
import script from "./ComponentSelector.vue?vue&type=script&lang=js&"
export * from "./ComponentSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c024e",
  null
  
)

export default component.exports